import { motion } from "framer-motion";
import { PLANS } from "@/data/services";
import { Button } from "@/components/ui/button";
import { Check, Star } from "lucide-react";
import { fadeUp } from "./variants";

export const PricingSection = () => {
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-5 sm:px-8 py-28">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <p className="text-sm tracking-[0.2em] uppercase font-semibold text-brand-dark mb-3">Subscriptions</p>
        <h2 className="text-3xl sm:text-5xl font-heading font-extrabold tracking-tight text-brand-dark">
          Ongoing advisory, on a plan that fits.
        </h2>
        <p className="text-gray-600 font-medium mt-4">Monthly consultancy retainers billed in TZS. Cancel anytime.</p>
      </div>
      <div className="grid gap-6 lg:grid-cols-3">
        {PLANS.map((p, i) => (
          <motion.div key={p.id} initial="hidden" whileInView="show" viewport={{ once: true }} custom={i} variants={fadeUp}>
            <div
              data-testid={`plan-card-${p.id}`}
              className={`relative h-full rounded-lg p-8 border ${
                p.highlight ? "bg-brand-dark border-brand-dark text-white shadow-xl" : "bg-brand-card border-gray-200 shadow-sm"
              }`}>
              {p.highlight && (
                <span className="absolute -top-3 left-8 bg-brand-yellow text-brand-dark font-semibold text-xs px-3 py-1 rounded-sm flex items-center gap-1">
                  <Star size={12} /> Most popular
                </span>
              )}
              <h3 className={`text-xl font-heading ${p.highlight ? "text-white" : "text-brand-dark"}`}>{p.name}</h3>
              <p className={`text-base font-medium mt-1 mb-6 min-h-[40px] ${p.highlight ? "text-gray-200" : "text-gray-600"}`}>{p.tagline}</p>
              <ul className="space-y-3 mb-8">
                {p.features.map((f) => (
                  <li key={f} className={`flex items-start gap-3 text-base font-medium ${p.highlight ? "text-gray-100" : "text-gray-700"}`}>
                    <Check size={16} className={`mt-0.5 shrink-0 ${p.highlight ? "text-brand-yellow" : "text-brand-blue"}`} /> {f}
                  </li>
                ))}
              </ul>
              <Button asChild data-testid={`plan-quote-${p.id}`}
                className={`w-full rounded-sm py-6 font-semibold ${p.highlight ? "bg-brand-yellow hover:bg-brand-yellowhover text-brand-dark" : "bg-brand-blue hover:bg-brand-bluehover text-white"}`}>
                <a href="tel:+19433008407">Contact us for a Quote</a>
              </Button>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
